module.exports = __webpack_public_path__ + "img/about-experiment-play-cook-up.84642754.jpg";